<template>
<div class="auction-sidebar">

	<b-nav vertical
	       class="w-100 h-100">
		<b-nav-item class="p-0"
		            :to="{ name: 'auction' }"
		            exact>{{ $t('common.auctionDashboard') }}</b-nav-item>
		<b-nav-item class="p-0"
		            :to="{ name: 'itemList'}">{{ $t('item.items') }}</b-nav-item>
		<b-nav-item class="p-0"
		            :to="{ name: 'itemOrders'}">{{ $t('item.orderingCounts') }}</b-nav-item>
		<b-nav-item class="p-0"
		            :to="{ name: 'bidList'}">{{ $t('common.bids') }}</b-nav-item>
		<b-nav-item class="p-0"
		            :to="{ name: 'pendingBidList' }">{{ $t('common.pendingBids') }}</b-nav-item>
		<b-nav-item class="p-0"
		            :to="generateUrl('sellers')">{{ $t('common.sellers') }}</b-nav-item>
		<b-nav-item class="p-0"
		            :to="generateUrl('buyers')">{{ $t('common.buyers') }}</b-nav-item>
		<b-nav-item class="p-0"
		            :to="{ name: 'auctionPhotos'}">{{ $t('auction.photos') }}</b-nav-item>
		<b-nav-item class="p-0"
		            :to="{ name: 'auctionLists'}">{{ $t('auction.lists') }}</b-nav-item>

	</b-nav>
</div>
</template>

<script>
import AuctionService from '@/services/auction-service.js'
import {
	mapActions,
	mapGetters
} from 'vuex'

export default {
	data() {
		return {

		}
	},
	computed: {
		...mapGetters([
			'activeAuction',
		]),
	},
	methods: {
		generateUrl(name) {
			return `/auction/${this.$route.params.auctionId}/${name}`;
		}
	}
}
</script>



// WEBPACK FOOTER //
// AuctionSidebar.vue?2f8c7b04